<template>
  <div class="HeroSection">
    <section class="hero-section rel z-1 bg-lighter">
      <!--      <b-carousel class="carousel full-screen" id="carousel-1" v-model="slide" :interval="4000" fade-out background="#ababab" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">-->
      <!--        <b-carousel-slide   class="full-screen" >-->
      <div
        class="d-sm-flex d-md-flex d-lg-flex align-items-center justify-content-between w-100"
        style="height: 90vh"
      >
        <div
          class="col-md-4 col-sm-12 col-lg-5 mx-auto mb-4 mb-sm-0 headline animate__animated animate__zoomInRight animate__delay-1s"
          style="padding: 10px"
        >
          <h1
            class="display-4 my-4 font-weight-bold"
            style="display: grid; justify-content: center"
          >
            Get there Your day
            <span style="color: #ffde20">belongs to you</span>
          </h1>
          <p class="text-secondary text-uppercase text-light">
            One tap and a car comes directly to you. Hop in—your driver knows
            exactly where to go. And when you get there, just step out. Payment
            is completely seamless.
          </p>
          <br />
          <br />
          <a
            href="#"
            class="btn px-5 py-3 text-white mt-3 mt-sm-0"
            style="
              border-radius: 30px;
              background-color: #ffde20;
              font-weight: 700;
              color: #2c3e50 !important;
            "
            >Get Started</a
          >
        </div>
        <!-- in mobile remove the clippath -->
        <div
          class="col-md-8 col-sm-12 col-lg-7 h-100 clipped fixed-backgound"
          style="
            min-height: 350px;
            background-image: linear-gradient(#f9f54b, #7d9d9c);
            background-position: center;
            background-size: cover;
            width: 59%;
          "
        >
          <img
            class="hero-img animate__animated animate__zoomInRight animate__delay-1s"
            src="@/assets/bee-taxi.png"
            alt="hero"
          />
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import 'animate.css';
export default {
  name: "HeroSection",
  props: {},
  data() {
    return {
      slide: 0,
      // sliding: null
    };
  },
};
</script>
<style scoped>
body {
  font-family: "Poppins", sans-serif !important;
}

.headline {
  left: 130px;
}
.clipped {
  clip-path: polygon(50% 0, 100% 0, 100% 100%, 0% 100%);
}
@media screen and (max-width: 650px) {
  .headline {
    left: 130px;
  }
  .clipped {
    clip-path: none;
    max-height: 300px !important;
  }
}
.hero-img {
  position: absolute;
  right: 5%;
  top: 31%;
  width: 33%;
}
.fixed-backgound {
  background-attachment: fixed;
}
.full-screen {
  height: 100vh;
  width: 100vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
h3 {
  font-size: 2em;
  text-shadow: 0px 4px 3px #000000;
}
.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 0 !important;
  left: 15%;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  color: #fff;
  text-align: center;
}
@media only screen and (max-width: 767px) {
  .clipped {
    display: none;
  }
}
</style>
